import React from 'react';
import { cn } from '../../utils/cn.ts';

interface ActHeaderRowProps {
    name: string;
    isPreset?: boolean;
    colSpan?: number;
    // Optional extra content to render after the main cell
    children?: React.ReactNode;
}

export const ActHeaderRow: React.FC<ActHeaderRowProps> = ({ 
    name, 
    isPreset = false, 
    colSpan = 1,
    children
}) => (
        <tr className="group bg-gray-100 dark:bg-surface-dark">
            <td 
                className={cn(
                    "border-l-4 px-4 py-3 font-bold text-xs uppercase tracking-wide",
                    isPreset 
                        ? "border-gray-400 text-gray-500"
                        : "border-primary text-primary"
                )} 
                colSpan={colSpan}
            >
                {name}
            </td>
            {children}
        </tr>
    );













